// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { EmployeeNameResponse } from './employee-name-response';

/** See com.rev360.pms.api.controller.admin.solutions.twelve84.Twelve84SubscriptionTableResponse */
/* istanbul ignore next */
@GandalfModel
export class Twelve84SubscriptionTableResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Number })
	id!: number | null;

	@GandalfProperty({ designType: String })
	kitReceivedByFirstName!: string | null;

	@GandalfProperty({ designType: String })
	kitReceivedByLastName!: string | null;

	@GandalfProperty({ designType: Date })
	kitReceivedDate!: Date | null;

	@GandalfConstantDecorator(constants.TwelveEightyFourKitStatus)
	@GandalfProperty({ designType: constants.TwelveEightyFourKitStatus })
	kitStatus!: constants.TwelveEightyFourKitStatus | null;

	@GandalfProperty({ designType: EmployeeNameResponse })
	locationContact!: EmployeeNameResponse | null;

	@GandalfProperty({ designType: Number })
	practiceLocationId!: number | null;

	@GandalfProperty({ designType: String })
	practiceLocationName!: string | null;

	@GandalfProperty({ designType: String })
	subscribedByFirstName!: string | null;

	@GandalfProperty({ designType: String })
	subscribedByLastName!: string | null;

	@GandalfProperty({ designType: Date })
	subscriptionDate!: Date | null;

	@GandalfConstantDecorator(constants.TwelveEightyFourSubscriptionStatus)
	@GandalfProperty({ designType: constants.TwelveEightyFourSubscriptionStatus })
	twelve84SubscriptionStatus!: constants.TwelveEightyFourSubscriptionStatus | null;

}
